import React from 'react';
import {
    SummaryRow,
    TotalSummaryCard
} from '../styles/BillingStyledComponents';

/**
 * 청구 합계 패널 — 구간 할인 + 최종 금액.
 *
 * 총 금액 / 사용량 기반 요금 / 보전 항목 행은 제거.
 * 보전 적용 여부는 BillingFinalTable의 행별 뱃지로 표시.
 *
 * props:
 *   - detail: billingDetail
 *   - isFinalAmount: 확정 여부 (라벨 분기: 최종금액 vs 예상금액)
 */
const BillingTotalsPanel = ({ detail, isFinalAmount }) => {
    if (!detail) return null;

    const discountFee = detail.discountFee || 0;
    const finalFee = detail.finalFee || 0;

    return (
        <div style={{ marginTop: '1.5rem' }}>
            {discountFee > 0 && (
                <SummaryRow className="discount">
                    <span className="label">구간 할인</span>
                    <span className="value">-₩{discountFee.toLocaleString()}</span>
                </SummaryRow>
            )}

            <TotalSummaryCard style={{ marginTop: discountFee > 0 ? '1rem' : 0 }}>
                <div className="summary-row highlight" style={{ margin: 0, padding: 0, border: 'none' }}>
                    <span className="summary-title" style={{ marginBottom: 0 }}>
                        {isFinalAmount ? '최종금액 (결제금액)' : '예상금액'}
                    </span>
                    <span className="summary-amount">₩{finalFee.toLocaleString()}</span>
                </div>
            </TotalSummaryCard>
        </div>
    );
};

export default BillingTotalsPanel;
